import React from "react";
import "./EraPage.css"; // Make sure this path is correct and at the top

function Medieval() {
  return (
    <div className="era-page">
      {/* Themed Banner */}
      <div className="era-banner medieval-banner">
        <h1>🛡️ The Medieval Era: Castles, Knights & Kingdoms</h1>
        <p className="era-subtitle">Grade 4 - Empires & Exploration</p>
      </div>

      {/* Overview */}
      <section className="medieval-overview">
        <h2>🏰 What Was the Medieval Era?</h2>
        <p>
          Also called the Middle Ages, this period stretched from around 500 CE to 1500 CE in Europe.
          People lived in castles, followed kings and queens, and knights followed a code of chivalry.
          It was also a time of art, religion, and new discoveries.
        </p>
      </section>

      {/* Key Figures & Events */}
      <section className="medieval-key">
        <h2>🧠 Key People & Moments</h2>
        <ul>
          <li>⚔️ <strong>Knights</strong> protected the land and swore loyalty to lords.</li>
          <li>👑 <strong>Charlemagne</strong> united much of Western Europe and was crowned emperor.</li>
          <li>🕍 <strong>Castles & Feudalism</strong>: Land was divided among nobles, and peasants worked the fields.</li>
          <li>📚 <strong>Monks</strong> copied ancient books by hand in monasteries.</li>
        </ul>
      </section>

      {/* Story Time */}
      <section className="medieval-story">
        <h2>📜 Tale of a Young Page: “Training to Become a Knight”</h2>
        <p>
          Young Leo dreamed of knighthood. He learned to ride horses, polish armor, and follow the rules of chivalry.
          One day, he would protect the kingdom and earn his own shining sword.
        </p>
      </section>

      {/* Media */}
      <section className="medieval-media">
        <h2>🎥 Explore the Middle Ages</h2>
        <img
  className="medieval-illustration"
  src="/images/medieval-era-scene.png" // rename as you like
  alt="Illustration of a medieval castle, knights in armor, a young page, and a monk with books"
  style={{ width: "100%", maxWidth: 500, borderRadius: "1.5rem", margin: "0 auto", boxShadow: "0 4px 24px rgba(0,0,0,0.12)" }}
/>
      </section>

      {/* Quiz */}
      <section className="medieval-quiz">
        <h2>🧠 Quick Quiz</h2>
        <ol>
          <li>What was a knight's job in the kingdom?</li>
          <li>What is a castle?</li>
          <li>What did monks do?</li>
        </ol>
        <p><em>(Try answering with a friend or parent!)</em></p>
      </section>

      {/* Timeline */}
      <section className="medieval-timeline">
        <h2>📅 Timeline</h2>
        <ul>
          <li>476 CE – Fall of the Western Roman Empire</li>
          <li>800 CE – Charlemagne crowned Emperor</li>
          <li>1096–1291 – The Crusades begin</li>
          <li>1347 – The Black Death hits Europe</li>
          <li>1453 – End of the Middle Ages (Fall of Constantinople)</li>
        </ul>
      </section>
    </div>
  );
}

export default Medieval;
